<template>
    <div class="navigator">
        <h2 class="mr-auto">{{ selectedProduct ? selectedProduct.name : 'New Product' }}</h2>
    </div>
</template>

<script>
    export default {
        props: {
            selectedProduct: {
                type: Object,
                required: false,
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ProductNavigator.vue?4b98d1a2